import { MODIFY_DATES_STATE } from './constants'

export const getIsFetching = state => state[MODIFY_DATES_STATE].isFetching
export const getBookingRules = state => state[MODIFY_DATES_STATE].bookingRules
export const getBoardSelected = state => state[MODIFY_DATES_STATE].boardSelected

export const getDatesAndPaxes = state => state[MODIFY_DATES_STATE].datesAndPaxes
export const getIsFetchingConfirmation = state => state[MODIFY_DATES_STATE].isFetchingConfirmation
export const getStep = state => state[MODIFY_DATES_STATE].step
export const getStatus = state => state[MODIFY_DATES_STATE].status
export const getError = state => state[MODIFY_DATES_STATE].error
